import { render, staticRenderFns } from "./CategoryDetailedView.vue?vue&type=template&id=007205f8&scoped=true"
import script from "./CategoryDetailedView.vue?vue&type=script&lang=js"
export * from "./CategoryDetailedView.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetailedView.vue?vue&type=style&index=0&id=007205f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007205f8",
  null
  
)

export default component.exports